export default __webpack_public_path__ + "static/media/Group 1463.501137a6.svg";